// Validation status chip — small echo of the Reality Check verdict on strategy
// cards, so weak strategies look weak before they're opened. Renders nothing
// for 'untested' (no clutter) — the data plumbing is wired in commit G.

import type { ValidationStatus } from '../../types/validation';
import { statusVisual } from './validationStatusVisual';

export default function ValidationStatusChip({ status }: { status: ValidationStatus }) {
  if (status === 'untested') return null;
  const v = statusVisual(status);
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-semibold rounded border ${v.classes}`}
      title={`Reality Check: ${v.full}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${v.dot}`} />
      {v.chip}
    </span>
  );
}
